import styled from 'styled-components';

export const UndoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
`;

export const UndoMessage = styled.span`
  font-size: 14px;
`;

export const UndoButton = styled.button`
  border: none;
  background: none;
  padding: 0;
  color: inherit;
  font-size: 14px;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
`;
